import angular from 'angular'

const checkboxComponent = angular
    .module('app.checkboxComponent', [])

export default checkboxComponent.name
checkboxComponent.component('checkboxComponent', {
    template: `
    <label class="et-cb-wrapper" for="{{$ctrl.hash_id}}">
        <input type="checkbox" id="{{$ctrl.hash_id}}" ng-model="$ctrl.model" ng-true-value="'1'" ng-false-value="'0'" name="" ng-disabled="$ctrl.disabled" ng-change="$ctrl.cb && $ctrl.cb()">
        <label class="et-cb-label" for="{{$ctrl.hash_id}}"></label>
        <span class="text" title="{{$ctrl.text}}">{{$ctrl.text}}</span>
    </label>
    `,
    bindings: {
        model: '=',
        text: '@',
        disabled: '<',
        cb: '&',
    },
    controller: [function () {
        this.$onInit = function () {
            const hash = (() => {
                const arr = []
                for (let i = 0; i < 100; i++) {
                    arr.push(Math.floor(Math.random() * 100))
                }
                return arr.join('')
            })()
            this.hash_id = `checkbox_${hash}` // 不重要的代码只是做随机ID
        }
    }],
})


// WEBPACK FOOTER //
// ./src/components/checkboxComponent/index.js